import { Injectable } from '@angular/core';
import { EventBusService } from '@web/common';

@Injectable({
  providedIn: 'root',
})
export class AdminSubscriptionOrderEventBusService extends EventBusService {}
